const initualState = {
  retirement: null,
  capital: null,
  retirementInputs: {
    currentAge: 0,
    retirementAge: 0,
    currentRSABalance: 0,
    contributionMonthly: 0,
    contributionAnnually: 0,
    rateOfReturn: 0
  },
  capitalInputs: {
    currentAge: 0,
    retirementAge: 0,
    currentRSABalance: 0,
    contributionMonthly: 0,
    contributionAnnually: 0,
    rateOfReturn: 0,
    retirementRSABalance: 0,
    payAfterRetirement: 0,
    lumpSumAmount: 0
  }
};

export default (state = initualState, action) => {
  switch (action.type) {
    case "SET_RETIREMENT_VALUES":
      return { ...state, retirement: action.payload };
    case "CLEAR_CALCULATORS":
      return { ...state, ...initualState };
    case "SET_CAPITAL_VALUES":
      return { ...state, capital: action.payload };
    case "SET_RETIREMENT_INPUTS": {
      return {
        ...state,
        retirementInputs: { ...state.retirementInputs, ...action.payload }
      };
    }
    case "SET_CAPITAL_INPUTS": {
      return {
        ...state,
        capitalInputs: { ...state.capitalInputs, ...action.payload }
      };
    }
    default:
      return state;
  }
};
